import { Component, Input } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTransferModule, TransferItem, TransferChange, TransferSelectChange } from 'ng-zorro-antd/transfer';
import { ApiService } from '../../../Services/api.service';
import { AuthService } from '../../../Services/auth.service';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-user-association',
  standalone: true,
  imports: [NzButtonModule, NzTransferModule, NzTableModule, NzCheckboxModule, FormsModule,NzInputModule,NzIconModule],
  templateUrl: './user-association.component.html',
  styleUrl: './user-association.component.scss'
})
export class UserAssociationComponent {
  constructor(private apiService: ApiService, public authService: AuthService) { }

  list: TransferItem[] = [];
  $asTransferItems = (data: unknown): TransferItem[] => data as TransferItem[];
  disabled = false;
  showSearch = true;
  catalogUsers: any = [];
  @Input() catalogId: string = '';
  leftUserListSearch = '';
  rightUserListSearch = '';



  ngOnInit(): void {
    this.apiService.getCatalogUsers(this.catalogId).subscribe(res => {
      this.catalogUsers = res;
      this.list = [
        ...this.catalogUsers.availableUsers.map((res: any, i: any) => ({
          key: i + 1,
          title: res,
          direction: 'left',
          checked: false
        })),
        ...this.catalogUsers.linkedUsers.map((res: any, i: any) => ({
          key: i + 1,
          title: res,
          direction: 'right',
          checked: false
        }))

      ];
    })
  }

  select(ret: TransferSelectChange): void {
  }

  change(ret: TransferChange): void {
    const listKeys = ret.list.map(l => l.key);
    const hasOwnKey = (e: TransferItem): boolean => e.hasOwnProperty('key');
    this.list = this.list.map(e => {
      if (listKeys.includes(e.key) && hasOwnKey(e)) {
        if (ret.to === 'left') {
          delete e.hide;
        } else if (ret.to === 'right') {
          e.hide = false;
        }
      }
      return e;
    });
  }

  UpdateUser() {
    if (!this.authService.webAdm)
      return;

    let addedUsers = this.list.filter(res => res.direction == 'right').map(data => data.title);

    this.apiService.updateCatalogUsers(this.catalogId, addedUsers).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.ngOnInit();
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

    onSearchChange(direction: string, value: string): void {
    const upper = value.toUpperCase();

    if (direction === 'left') {
      this.leftUserListSearch = upper;
    } else {
      this.rightUserListSearch = upper;
    }
  }

  matchSearch(item: any, direction: string): boolean {
    const search =
      direction === 'left' ? this.leftUserListSearch : this.rightUserListSearch;

    if (!search) return true;

    return item.title?.toUpperCase().includes(search);
  }

}